import history from '../../../history';

/**
 * @param {number} page
 * @param {string} [pageParam='page'] query param name (e.g. `notesPage` on application detail)
 */
export const handlePageClick = (page, pageParam = 'page') => {
  const searchParams = new URLSearchParams(history.location.search);
  searchParams.set(pageParam, String(page));

  history.push(`${history.location.pathname}?${searchParams.toString()}`);
};

/**
 * @param {number} totalPages
 * @param {string} [pageParam='page']
 */
export const handleNextPageClick = (totalPages, pageParam = 'page') => {
  const searchParams = new URLSearchParams(history.location.search);
  const searchEntries = Object.fromEntries(searchParams);
  const page = searchEntries[pageParam] ? Number(searchEntries[pageParam]) : 1;

  if (page < totalPages) {
    searchParams.set(pageParam, String(page + 1));
    history.push(`${history.location.pathname}?${searchParams.toString()}`);
  }
};

/**
 * @param {string} [pageParam='page']
 */
export const handlePreviousPageClick = (pageParam = 'page') => {
  const searchParams = new URLSearchParams(history.location.search);
  const searchEntries = Object.fromEntries(searchParams);
  const page = searchEntries[pageParam] ? Number(searchEntries[pageParam]) : 1;

  if (page >= 2) {
    searchParams.set(pageParam, String(page - 1));
    history.push(`${history.location.pathname}?${searchParams.toString()}`);
  }
};